<template>
  <div class="login">
    <div class="main">
      <div class="login_text_wrapper">
        <p v-if="loginType === 'account'" class="login_text">账号登录</p>
        <p v-if="loginType === 'verify'" class="login_text">手机验证码登录</p>
      </div>
      <div class="login_wrapper">
        <div class="account_login" v-if="loginType === 'account'">
          <div class="input_wrapper">
            <span class="label"> 账号:</span>
            <el-input v-model="accountForm.accountNum" clearable></el-input>
          </div>
          <div class="input_wrapper">
            <span class="label"> 密码:</span>
            <el-input
              type="password"
              v-model="accountForm.password"
              show-password
              @keyup.enter.native="loginHandle"
            ></el-input>
          </div>

          <el-button
            style="width: 320px; margin-top: 20px"
            type="primary"
            @click="loginHandle"
            >登录</el-button
          >
          <el-button
            class="toggle_btn"
            @click="loginToggle('verify')"
            type="text"
            >手机验证码登录</el-button
          >
        </div>

        <div class="account_login" v-if="loginType === 'verify'">
          <div class="input_wrapper">
            <el-input placeholder="手机号" type="text" v-model="tel">
              <el-button
                :disabled="isSend"
                slot="suffix"
                type="text"
                @click="sandVerifyCode"
                style="margin-right: 6px"
                >{{ btnText }}</el-button
              >
            </el-input>
          </div>
          <div class="input_wrapper" style="margin-bottom: 8px">
            <el-input
              placeholder="验证码"
              type="text"
              v-model="verifyCode"
            ></el-input>
          </div>
          <p>
            新用户登录即自动注册，默认密码为<b style="color: #808080"
              >手机号后6位</b
            >
          </p>
          <el-button
            style="width: 320px; margin-top: 20px"
            type="primary"
            @click="loginHandle2"
            >登录</el-button
          >
          <el-button
            class="toggle_btn"
            @click="loginToggle('account')"
            type="text"
            >账号登录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchToken, accountLogin, sendVerifyCode, mobileLogin } from '@/apis'
import { setToken } from '@/utils/auth'

export default {
  name: 'Login',
  mounted() {
  },

  data() {
    return {
      loginType: 'account',
      accountForm: {
        accountNum: '',
        password: ''
      },
      tel: '',
      verifyCode: '',
      isSend: false,
      btnText: '获取验证码'
    }
  },
  methods: {
    loginToggle(type) {
      this.loginType = type
    },
    // 账号登录
    async loginHandle() {
      if (this.accountForm.accountNum === '' || this.accountForm.password === '') {
        return this.$message.warning('账号或密码不能为空')
      }
      const data = await accountLogin({ username: this.accountForm.accountNum, password: this.accountForm.password })
      console.log(data);

      if (data.code === 1) {
        this.$message.success('登录成功')
        sessionStorage.setItem('isActive', 0);
        sessionStorage.setItem('isActive2', 0);
        sessionStorage.setItem('isActive3', 0);
        localStorage.setItem('userInfo', JSON.stringify(data.data))
        setToken(data.data.token)
        this.$router.push({ path: '/classroom' });

      } else {
        this.$message.error(data.msg)
      }
    },
    async loginHandle2() {
      if (this.tel === '') {
        return this.$message.warning('请输入手机号')
      }
      else if (!/^1[345678]\d{9}$/.test(this.tel)) {
        return this.$message.warning('请输入正确的手机号')
      } else if (this.verifyCode === '') {
        return this.$message.warning('请输入验证码')
      }
      const data = await mobileLogin({ mobile: this.tel, captcha: this.verifyCode })
      if (data.code === 1) {
        this.$message.success('登录成功')
        sessionStorage.setItem('isActive', 0);
        sessionStorage.setItem('isActive2', 0);
        sessionStorage.setItem('isActive3', 0);
        localStorage.setItem('userInfo', JSON.stringify(data.data))
        setToken(data.data.token)
        this.$router.push({ path: '/classroom' });
      } else {
        this.$message.error(data.msg)
      }
    },
    //验证码登录
    sandVerifyCode() {
      if (this.tel === '') {
        return this.$message.warning('请输入手机号')
      }
      else if (!/^1[345678]\d{9}$/.test(this.tel)) {
        return this.$message.warning('请输入正确的手机号')
      }
      this.getVerifyCode()
      this.isSend = true
      this.btnText = '请30秒钟后重试'
      let time = 29
      let timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          this.isSend = false
          this.btnText = '获取验证码'
        } else {
          this.btnText = '请' + time + '秒钟后重试'
          time--
        }
      }, 1000);
    },
    async getVerifyCode() {
      const res = await sendVerifyCode({ mobile: this.tel })
      if (res.code) {
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    }

  }
}

</script>

<style scoped lang=scss>
.login {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  z-index: 99;
}

.main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 420px;
  height: 420px;
  margin-top: -10vh;
  background-color: #fff;
  box-shadow: 0px 0px 2px 2px rgb(230, 230, 230);
  .login_toggle {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
  }
}
.login_text_wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100px;
  border-bottom: 2px solid #f2f2f2;
  .login_text {
    margin-bottom: 14px;
    color: #447bff;
  }
  &:before {
    position: absolute;
    bottom: 0;
    content: "";
    width: 48px;
    height: 4px;
    background-image: linear-gradient(to right, #5999ff, #447bff);
    border-radius: 2px;
  }
}
.login_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  .account_login {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-top: 60px;
    .input_wrapper {
      display: flex;
      justify-content: space-between;
      width: 320px;
      margin-bottom: 24px;
      .label {
        width: 66px;
        line-height: 40px;
        margin-right: 10px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    p {
      font-size: 14px;
      color: #a1a1a1;
    }
    .toggle_btn {
      position: absolute;
      bottom: 10px;
      margin: 0;
    }
  }
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
}
::v-deep .el-dialog__close {
  color: #ccc !important;
}
</style>